import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postTranslationKey = (params) => {
  return axiosClient
    .post(`api/translations/save-key`, params)
    .then((r) => r.data);
};
